import { render, staticRenderFns } from "./v8.vue?vue&type=template&id=cf9c2f26&"
import script from "./v8.vue?vue&type=script&lang=js&"
export * from "./v8.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports